// Free Gift Configuration
const GIFT_VARIANT_ID = 53479106216320;
const MINIMUM_AMOUNT = 5000;

// Get cart data
async function getCart() {
  const response = await fetch('/cart.js');
  return await response.json();
}

// Add gift to cart
async function addGift() {
  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: GIFT_VARIANT_ID,
          quantity: 1,
          properties: { '_free_gift': 'true' }
        }]
      })
    });
    if (response.ok) {
      console.log('✅ Free gift added');
      return true;
    }
    return false;
  } catch (error) {
    console.error('Error adding gift:', error);
    return false;
  }
}

// Remove gift from cart
async function removeGift(lineKey) {
  try {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    });
    if (response.ok) {
      console.log('✅ Free gift removed');
      return true;
    }
    return false;
  } catch (error) {
    console.error('Error removing gift:', error);
    return false;
  }
}

// Main function to check and update gift
async function checkAndUpdateGift() {
  try {
    const cart = await getCart();

    const giftItem = cart.items.find(item =>
      item.variant_id === GIFT_VARIANT_ID ||
      (item.properties && item.properties._free_gift)
    );

    const qualifies = cart.total_price >= MINIMUM_AMOUNT;

    if (qualifies && !giftItem) {
      await addGift();
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
    } else if (!qualifies && giftItem) {
      await removeGift(giftItem.key);
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
    }
  } catch (error) {
    console.error('Error checking gift:', error);
  }
}

// Run when DOM is loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', checkAndUpdateGift);
} else {
  checkAndUpdateGift();
}

// Run when cart updates
document.addEventListener('cart:refresh', checkAndUpdateGift);
document.addEventListener('cart:updated', checkAndUpdateGift);

// Run on quantity change (debounced)
let debounceTimer;
document.addEventListener('change', function(e) {
  if (e.target.name === 'updates[]' || e.target.classList.contains('quantity')) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(checkAndUpdateGift, 1000);
  }
});

console.log('🎁 Free gift script loaded');